import PropTypes from 'prop-types';

import { trans, getPagePath } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { useStateMachineContext } from '@spotahome/landings-common/src/context/StateMachineContext';

import { TENANT_CONFIG } from '../../constants';

import ContactUsHeader from '../ContactUsHeader';

import './ContactCategories.scss';

const getCategories = () => Object.keys(TENANT_CONFIG);

const ContactCategories = ({
  isHeaderInvisible = false,
  isSupportSection = false
}) => {
  const { payload, send } = useStateMachineContext();

  const baseLocoKey = `contact-us.${payload.role}`;
  const headerLocoKey = isSupportSection ? 'contact-us.go-back' : baseLocoKey;

  const handleCategoryClicked = categoryId => {
    if (categoryId === 'booking') {
      window.location.href = getPagePath('my-bookings');
    } else {
      send('SELECT', { categoryId });
    }
  };

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader
        title={trans(headerLocoKey)}
        isInvisible={isHeaderInvisible}
        onBack={
          isSupportSection
            ? () => (window.location.href = getPagePath('support'))
            : false
        }
      />
      {getCategories().map(category => (
        <Button
          dataTest={`${category}-button`}
          key={category}
          color="primary"
          size="large"
          fullWidth
          onClick={() => handleCategoryClicked(category)}
          className="contact-us-form__button"
        >
          {trans(`${baseLocoKey}.${category}`)}
        </Button>
      ))}
    </div>
  );
};

ContactCategories.propTypes = {
  isHeaderInvisible: PropTypes.bool,
  isSupportSection: PropTypes.bool
};

export default ContactCategories;
